export default "__VITE_ASSET__D4$r_mfx__"